import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="OT2 Any% Hikari DPS" mdxType="SEO" />
    <p>{`Start Throne`}</p>
    <h3 {...{
      "id": "new-delsta-throne-1"
    }}>{`New Delsta (Throne 1)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "pursuer-1"
      }}>{`Pursuer 1`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`C1: Attack`}</li>
        <li parentName="ul">{`C2: Attack x2 Pursuer 2`}</li>
        <li parentName="ul">{`C3: Attack Pursuer 1`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`C1&C3: Attack x3 each Pursuer`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "pursuer-2"
      }}>{`Pursuer 2`}</h4>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Darkest Night #1 (Front)	`}</li>
        <li parentName="ul">{`Pirro: Pierce Through Leader	`}</li>
        <li parentName="ul">{`Scaracci:	Attack #2 (Back)	`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Darkest Night x3 Leader	`}</li>
        <li parentName="ul">{`Pirro: Slice x3 #2 (Back)	`}</li>
        <li parentName="ul">{`Scaracci: Axe x3 #1 (Front)	`}</li>
      </ul>
    </Battle>
    <p>{`Continue with the story until after the day cutscene with Father.						`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Brothel Girl's Clothes`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Herb of Clarity (Better Stone Positions)`}</strong>{`, `}<strong parentName="p">{`Gold Ring`}</strong>{` from Brothel Receptionist	`}<br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Shadow Soulstone`}</strong>{`, `}</p>
    <p>{`Steal `}<strong parentName="p">{`Ice, Wind, Light Soulstone`}</strong>{` from Artist (south of Equip shop)	`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-buy"
      }}>{`Equipment Buy`}</h5>
      <ul>
        <li parentName="ul">{`Unerring Earring					`}</li>
      </ul>
    </Menu>
						
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "pirro"
      }}>{`Pirro`}</h4>
      <ol>
        <li parentName="ol">{`Darkest Night`}</li>
        <li parentName="ol">{`Darkest Night`}</li>
        <li parentName="ol">{`Darkest Night x4`}</li>
        <li parentName="ol">{`Sword`}</li>
        <li parentName="ol">{`Sword (break)`}</li>
        <li parentName="ol">{`Shadow Soulstone`}</li>
        <li parentName="ol">{`(Healing Grape if after Pirro next turn)`}</li>
        <li parentName="ol">{`Light Soulstone`}</li>
        <li parentName="ol">{`Sword x4 (break)`}</li>
        <li parentName="ol">{`[LP]`}{` Wind Soulstone, Ice Soulstone`}</li>
        <li parentName="ol">{`Sword`}</li>
      </ol>
    </Battle>
    <p>{`Tag `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`. Tag `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go towards `}<strong parentName="p">{`Cape Cold`}</strong>{`, get `}<strong parentName="p">{`Osvald`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cape-cold"
    }}>{`Cape Cold`}</h3>
    <p>{`Mug Retired Scholar for Gold Items (Defend, Staff, Fireball x4) or Icewind, Fireball x3 (can miss kill if unlucky)`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$2000`}</strong>{`. TP `}<strong parentName="p">{`Abandoned Village`}</strong>{` and head to Black Market.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Herb of Serenity`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "soulstone-merchant-sell"
      }}>{`Soulstone Merchant (Sell)`}</h5>
      <ul>
        <li parentName="ul">{`Gold Items`}</li>
      </ul>
      <h5 {...{
        "id": "soulstone-merchant-buy"
      }}>{`Soulstone Merchant (Buy)`}</h5>
      <ul>
        <li parentName="ul">{`2 Ice S`}</li>
        <li parentName="ul">{`1 Thunder S`}</li>
        <li parentName="ul">{`2 Fire M`}</li>
        <li parentName="ul">{`2 Ice M`}</li>
        <li parentName="ul">{`6 Light M`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Abandoned Waterway`}</strong></p>
    <h3 {...{
      "id": "abandoned-waterway"
    }}>{`Abandoned Waterway`}</h3>
    <p>{`Kill battle with Ice M, pick `}<strong parentName="p">{`$8000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`, take boat to `}<strong parentName="p">{`Toto'haha`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Go towards `}<strong parentName="p">{`Tropu'hopu`}</strong>{`. Probably worth walking this screen to skip a battle.`}<br parentName="p"></br>{`
`}{`Kill battle with Light M. `}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +Armor Corrosive`}</li>
        <li parentName="ul">{`Osvald: +Lightning Bolt +Analyze`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: +`}{`[2]`}{`Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Get `}<strong parentName="p">{`Hunter Guild`}</strong>{`. Reset steps with Mug. Walk till bit before the save point and tag `}<strong parentName="p">{`Tropu'hopu`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{` and take boat to `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-harbor"
    }}>{`Crackridge Harbor`}</h3>
    <p>{`Can walk to `}<strong parentName="p">{`Cropdale`}</strong>{` for a good chance to skip the battle. Tag `}<strong parentName="p">{`Cropdale`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Slumber Sage`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Oresrush`}</strong>{`.`}</p>
    <h3 {...{
      "id": "oresrush-throne-c2m-p1"
    }}>{`Oresrush (Throne C2M P1)`}</h3>
    <p>{`Get `}<strong parentName="p">{`Partitio`}</strong>{`. TP `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{` and take boat to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Get Castii.`}<br parentName="p"></br>{`
`}{`Go to Weapon Shop, buy `}<strong parentName="p">{`Critical Earring`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`, head to `}<strong parentName="p">{`Ryu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ryu"
    }}>{`Ryu`}</h3>
    <p>{`Talk to Item Shop before triggering recruitment`}</p>
    <Menu mdxType="Menu">
      <h3 {...{
        "id": "buy"
      }}>{`Buy`}</h3>
      <ul>
        <li parentName="ul">{`1 Sticky Flower`}</li>
        <li parentName="ul">{`1 Blusterbloom`}</li>
      </ul>
    </Menu>
    <p>{`Get `}<strong parentName="p">{`Hikari`}</strong>{`, Battle Ice S + Attack x2.`}<br parentName="p"></br>{`
`}{`Exit Ryu, head to `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <p>{`Ryu screen walk till past first metal post, then run.`}</p>
    <p>{`For both Conning Creek battles switch to night before battle, Light M.`}</p>
    <h3 {...{
      "id": "conning-creek-osvald-c3-p1"
    }}>{`Conning Creek (Osvald C3 P1)`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Wind L`}</strong>{`. Pick `}<strong parentName="p">{`Rainbow Bottle`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta"
    }}>{`New Delsta`}</h3>
    <p>{`Go to and get `}<strong parentName="p">{`Inventor`}</strong>{` and `}<strong parentName="p">{`A Step Ahead`}</strong>{`.`}</p>
    <p>{`After getting Inventor head to `}<strong parentName="p">{`Clockbank`}</strong>{`.`}</p>
    <h3 {...{
      "id": "clockbank-partitio-c2-p1"
    }}>{`Clockbank (Partitio C2 P1)`}</h3>
    <p>{`After Clockite TP `}<strong parentName="p">{`Crackridge Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-anchrorage"
    }}>{`Crackridge Anchrorage`}</h3>
    <p>{`Head towards `}<strong parentName="p">{`Crackridge`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +`}{`[1]`}{`ASA`}</li>
        <li parentName="ul">{`Hikari: +`}{`[1]`}{`ASA`}</li>
        <li parentName="ul">{`Partitio: +`}{`[1]`}{`ASA`}</li>
        <li parentName="ul">{`Osvald: +`}{`[1]`}{`ASA`}</li>
      </ul>
    </Menu>
    <p>{`Crackridge Battles break Armor Eater and kill with Light M.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Merchant`}</strong>{`, Pick `}<strong parentName="p">{`Thunder M`}</strong>{`. Reset steps with Challenge. `}</p>
    <p>{`Tag `}<strong parentName="p">{`Crackridge`}</strong>{`. TP `}<strong parentName="p">{`Clockbank`}</strong>{`.`}</p>
    <h3 {...{
      "id": "clockbank-partitio-c2-p2"
    }}>{`Clockbank (Partitio C2 P2)`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Mighty Belt`}</strong>{`.`}</p>
    <p>{`Kill forced and random battle with Fire M.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$7000`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Merchant, +Collect +Hired Help`}</li>
        <li parentName="ul">{`Osvald: Hunter`}</li>
        <li parentName="ul">{`Partitio: +Collect +Hired Help`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "garnet-23000hp-5s-spear-axe-fire-thunder"
      }}>{`Garnet 23000HP 5S (Spear Axe Fire Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Spear`}</li>
        <li parentName="ul">{`Osvald: Defend`}</li>
        <li parentName="ul">{`Partitio: Attack`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Axe x3`}</li>
        <li parentName="ul">{`Hikari: Spear x3`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
        <li parentName="ul">{`Partitio: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`M1: Collect x4`}</li>
        <li parentName="ul">{`M2: HHG x4`}</li>
      </ul>
    </Battle>
    <p>{`Go to `}<strong parentName="p">{`Flamechurch`}</strong>{`. Do this menu asap, it makes failed flees suck less.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Merchant, +Collect +Donate BP +Hired Help`}</li>
        <li parentName="ul">{`Partitio: +Ember, Inventor`}</li>
        <li parentName="ul">{`Osvald: Merchant, +Collect +Ember +Hired Help`}</li>
        <li parentName="ul">{`Throne: +HP Thief, Merchant, +Ember`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +`}{`[2]`}{`Grow On Trees +`}{`[3]`}{`Boost-Start`}</li>
        <li parentName="ul">{`Hikari: +`}{`[4]`}{`Grow On Trees +`}{`[2]`}{`Boost-Start`}</li>
        <li parentName="ul">{`Partitio: +`}{`[2]`}{`Grow On Trees +`}{`[3]`}{`Boost-Start`}</li>
        <li parentName="ul">{`Osvald: +`}{`[3]`}{`Grow on Trees +`}{`[4]`}{`Boost-Start -`}{`[1]`}{`A Step Ahead `}</li>
      </ul>
    </Menu>
    <p>{`Tag `}<strong parentName="p">{`Flamechurch`}</strong>{`. Run from small battles (can S&Q) on screen outside Flamechurch.`}</p>
    <p>{`Run from Bolderfall battle. Pick Thunder M.`}</p>
    <h3 {...{
      "id": "montwise-hikari-c2"
    }}>{`Montwise (Hikari C2)`}</h3>
    <p>{`Battle 1: Spear x3, Light M (Don't Learn Thrash)`}<br parentName="p"></br>{`
`}{`Battle 2: Ice M`}<br parentName="p"></br>{`
`}{`Zeto: Thunder M, Attack x3, Thunder M (LEARN Slowing Sweep)`}<br parentName="p"></br>{`
`}{`Bandelam: Spear/Slowing Sweep, Spear x4, Wind L`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "bandelam-20000hp-6s-spear-dagger-axe-fire-light"
      }}>{`Bandelam 20000HP 6S (Spear Dagger Axe Fire Light)`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Attack x3`}</li>
        <li parentName="ul">{`Hikari: Spear x3`}</li>
        <li parentName="ul">{`Throne: AC`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HHG x4`}</li>
      </ul>
    </Battle>
    <p>{`Switch to Night, re-enter Arena. Ambush Fainthearted Youth.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "yurinas-30000hp-6s-sword-dagger-axe-ice-wind"
      }}>{`Yurinas 30000HP 6S (Sword Dagger Axe Ice Wind)`}</h4>
      <p>{`T1: `}{`[LP]`}{` if 2nd T2 Armor Corrosive, Defend`}<br parentName="p"></br>{`
`}{`T2: HHV x4`}</p>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +Champ Belt +Mighty Belt`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Flamechurch`}</strong>{`.`}</p>
    <h3 {...{
      "id": "flamechurch"
    }}>{`Flamechurch`}</h3>
    <p>{`Insurgent: Throne Attack x2`}</p>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`. Go to house, pick `}<strong parentName="p">{`Fire M`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "clarissa-8212hp-5s-spear-dagger-thunder"
      }}>{`Clarissa 8212HP 5S (Spear Dagger Thunder)`}</h4>
      <p>{`Defend, HHG x4`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong></p>
    <h3 {...{
      "id": "oresrush-throne-c2m-p2"
    }}>{`Oresrush (Throne C2M P2)`}</h3>
    <p>{`Go to Horseshoe maker for quest.`}<br parentName="p"></br>{`
`}{`Hire `}<strong parentName="p">{`Peddler (25% Refund on Sales)`}</strong><br parentName="p"></br>{`
`}{`Steal `}<strong parentName="p">{`Forget-Me-Do`}</strong>{`, Buy `}<strong parentName="p">{`Sturdy Pickaxe`}</strong>{`.`}</p>
    <p>{`Finish Chapter, TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-osvald-c3-p3"
    }}>{`Conning Creek (Osvald C3 P3)`}</h3>
    <p>{`Kill battle with Fire M.`}</p>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` before Stenvar.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "stenvar-19000hp-5s-sword-spear-bow-thunder-shadow"
      }}>{`Stenvar 19000HP 5S (Sword Spear Bow Thunder Shadow)`}</h4>
      <p>{`T1: Merchants Defend`}<br parentName="p"></br>{`
`}{`T2: M1 Collect x4, M2 HHB x4`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise-osvald-c4"
    }}>{`Montwise (Osvald C4)`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Light M & Shadow M`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you need to restore reputation here, will want to pickup either Fire L or Thunder L for Shadow Hikari.`}</p>
    </blockquote>
    <p>{`Underground Laboratory: Pick `}<strong parentName="p">{`$14000`}</strong>{`. Travel Banter at bottom left corner of wall with next doorway. Run rest. `}<strong parentName="p">{`SWITCH TO NIGHT`}</strong></p>
    <p>{`Kill forced battle with `}<strong parentName="p">{`Partitio`}</strong>{` HHG x3`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-skills-3"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: +`}{`[1]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Osvald: +`}{`[1]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "grieving-golem-620000hp-7s-spear-staff-wind-light"
      }}>{`Grieving Golem 620000HP 7S (Spear Staff Wind Light)`}</h4>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Spear`}</li>
        <li parentName="ul">{`Osvald: Attack x3`}</li>
        <li parentName="ul">{`Partitio: Crit Scope`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Attack x3`}</li>
        <li parentName="ul">{`Throne: HHG x4`}</li>
        <li parentName="ul">{`Osvald: Shadow M`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Cape Cold`}</strong>{` and head to `}<strong parentName="p">{`Winterbloom`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Inventor`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-4"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Oswald: -`}{`[1]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Partitio: -`}{`[1]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Temenos: -`}{`[1]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <p>{`Kill both Winterbloom screen battles at night with Catapult x3.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Scholar Guild`}</strong>{`.`}</p>
    <h3 {...{
      "id": "winterbloom-castti-c2w"
    }}>{`Winterbloom (Castti C2W)`}</h3>
    <p>{`Don't Start Chapter.`}<br parentName="p"></br>{`
`}{`Go to Tavern, Scrutinize for better Inquires.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`Castti > Osvald`}</li>
      </ul>
      <h5 {...{
        "id": "hear-a-tale"
      }}>{`Hear a Tale`}</h5>
      <p>{`Castti`}</p>
    </Menu>
    <p>{`Turn in Sturdy Pickaxe for quest.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: Scholar, +Lightning Bolt +Analyze`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-5"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: -`}{`[1]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Partitio: +`}{`[1]`}{`Evasive Maneuvers +`}{`[4]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h5 {...{
        "id": "plukk-16000hp-mikk-12000hp-makk-13000hp"
      }}>{`Plukk 16000HP, Mikk 12000HP, Makk 13000HP`}</h5>
      <p>{`Defend, HHB x4.`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge"
    }}>{`Crackridge`}</h3>
    <p>{`Exit & head to Gravell.`}<br parentName="p"></br>{`
`}{`Shadow Battle: Partitio Defend, Attack x4 to break.`}</p>
    <ul>
      <li parentName="ul">{`Aurochs: Spear		`}</li>
      <li parentName="ul">{`Birdking: Bow		`}</li>
      <li parentName="ul">{`Armor: Staff`}</li>
    </ul>
    <p>{`Gravell Screen switch to night before battle, Defend > HHG x4.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-4"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Scholar, +2 Skills`}</li>
        <li parentName="ul">{`Temenos: +4 Skills (Skip Prayer to the Flame), Merchant`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-6"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +`}{`[1]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Temenos: +`}{`[4]`}{`Evil Ward`}</li>
        <li parentName="ul">{`Castti: +`}{`[1]`}{`EM`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "gravell"
    }}>{`Gravell`}</h3>
    <p>{`Soothe guy guarding Armsmaster house. Get `}<strong parentName="p">{`Armsmaster`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Item Shop. Buy `}<strong parentName="p">{`Herb of Serenity`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Conqueror's Blade`}</li>
        <li parentName="ul">{`Drifting Dagger`}</li>
        <li parentName="ul">{`Axe of Avarice`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`, head to `}<strong parentName="p">{`Stormhail`}</strong>{`. Soothe guard. Go to `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stormhail"
    }}>{`Stormhail`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Herb of Serenity`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Tropu'hopu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tropuhopu"
    }}>{`Tropu'hopu`}</h3>
    <p>{`Go buy Boat!`}</p>
    <h3 {...{
      "id": "sea"
    }}>{`Sea`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Roque Island Anchorage`}</strong>{`. Tag `}<strong parentName="p">{`Roque Island`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`, head to `}<strong parentName="p">{`Sai`}</strong>{`.`}</p>
    <h3 {...{
      "id": "sai-castti-c2s"
    }}>{`Sai (Castti C2S)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "sand-lion-22500hp-5s-spear-axe-ice-light-shadow"
      }}>{`Sand Lion 22500HP 5S (Spear Axe Ice Light Shadow)`}</h4>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHV x3`}</li>
      </ul>
    </Battle>
    <p>{`Head to `}<strong parentName="p">{`Wellgrove`}</strong></p>
    <h3 {...{
      "id": "wellgrove-partitio-c3-p1"
    }}>{`Wellgrove (Partitio C3 P1)`}</h3>
    <p>{`Exit and head to `}<strong parentName="p">{`Timberain`}</strong>{`, running from all battles.`}</p>
    <h3 {...{
      "id": "timberain"
    }}>{`Timberain`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Wind L`}</strong>{` & `}<strong parentName="p">{`Light L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Rusty Spear`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`. Get on Boat. Go to `}<strong parentName="p">{`Shipwreck of the Empress`}</strong>{`.`}</p>
    <h3 {...{
      "id": "shipwreck-of-the-empress"
    }}>{`Shipwreck of the Empress`}</h3>
    <p>{`Run from battle. Pick `}<strong parentName="p">{`Rusty Dagger`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-village-castti-c3"
    }}>{`Abandoned Village (Castti C3)`}</h3>
    <p>{`Just finish chapter. It puts you at New Delsta Anchorage, get on boat.`}</p>
    <h3 {...{
      "id": "sea-1"
    }}>{`Sea`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Exp Augmentor`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Gravell`}</strong>{`.`}</p>
    <h3 {...{
      "id": "gravell-1"
    }}>{`Gravell`}</h3>
    <p>{`Go to Armsmaster, turn in `}<strong parentName="p">{`Rusty Spear & Rusty Dagger`}</strong>{` for `}<strong parentName="p">{`Warlord's Spear & Dancing Dagger`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wellgrove-partitio-c3-p2"
    }}>{`Wellgrove (Partitio C3 P2)`}</h3>
    <p>{`Talk to shopkeeper.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Warlord's Spear`}</li>
      </ul>
    </Menu>
    <p>{`After tavern Cutscene, talk to Tavern Keeper.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-1"
      }}>{`Party`}</h5>
      <p>{`[2]`}{`Hikari > `}{`[2]`}{`Castti`}</p>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Dancing Dagger: Throne`}</li>
        <li parentName="ul">{`EXP Augmentor: Temenos`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-7"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: +`}{`[4]`}{`Peak Performance`}</li>
      </ul>
    </Menu>
    <p>{`After buying stuff, `}<strong parentName="p">{`Switch to Night`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "thurston-35000hp-4s-sword-axe-bow-ice-wind-collect-17000"
      }}>{`Thurston 35000HP 4S (Sword Axe Bow Ice Wind) Collect $17000`}</h4>
      <h4 {...{
        "id": "steam-engine-7500hp-spear-dagger-fire-thunder"
      }}>{`Steam Engine 7500HP (Spear Dagger Fire Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x3 Steam Engine`}</li>
        <li parentName="ul">{`Partitio: Attack / Defend if before Hikari`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Attack x4`}</li>
        <li parentName="ul">{`Partitio: HHV x4`}</li>
      </ul>
    </Battle>
    <p>{`Go to Tavern, Hear a Tale to start Hikari 3.`}</p>
    <h3 {...{
      "id": "wellgrove-hikari-c3"
    }}>{`Wellgrove (Hikari C3)`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-5"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: +Collect +Ember +Hired Help, `}<strong parentName="li">{`Scholar`}</strong>{`, +Lightning Bolt +Elemental Barrage, `}<strong parentName="li">{`Hunter`}</strong>{`, +Abating Orb`}</li>
        <li parentName="ul">{`Hikari: `}<strong parentName="li">{`Merchant`}</strong></li>
      </ul>
      <h5 {...{
        "id": "equip-skills-8"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: +`}{`[1]`}{`EM +`}{`[2]`}{`Boost Start +`}{`[3]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <p>{`Battle: Light L`}<br parentName="p"></br>{`
`}{`Challenge: Defend, HHB x4`}</p>
    <p>{`TP `}<strong parentName="p">{`Roque Island`}</strong>{`.`}</p>
    <h3 {...{
      "id": "roque-island-partitio-c4"
    }}>{`Roque Island (Partitio C4)`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$24500`}</strong>{`.`}</p>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` after Purchasting Rights.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "steam-tank-obsidian-70000hp-8s-spear-bow-shadow-collect-52000"
      }}>{`Steam Tank Obsidian 70000HP 8S (Spear Bow Shadow) Collect $52000`}</h4>
      <blockquote>
        <p parentName="blockquote">{`If Throne Latent, just `}{`[LP]`}{` Crit Scope, Defend, & Merchants Defend. Then HHV x8 and HP Thief x4`}<br parentName="p"></br>{`
`}{`Can just have Partitio Latent if he has it instead of Rev Jam strat.`}<br parentName="p"></br>{`
`}{`Prioritize Throne Latent strat here.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope Steam Tank Obsidian`}</li>
        <li parentName="ul">{`Temenos: Abating Orb Steam Tank Obsidian`}</li>
        <li parentName="ul">{`M1: Rev Jam M2`}</li>
        <li parentName="ul">{`M2: HHG x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: HP Thief x4 Steam Tank Obsidian`}</li>
        <li parentName="ul">{`Merchants: HHV x7`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stormhail-hikari-c4"
    }}>{`Stormhail (Hikari C4)`}</h3>
    <p>{`Switch to Night.`}</p>
    <h5 {...{
      "id": "kunzo"
    }}>{`Kunzo`}</h5>
    <p>{`HHB x3`}</p>
    <h5 {...{
      "id": "jin-mei"
    }}>{`Jin Mei`}</h5>
    <p>{`Attack, Attack, Defend, Wild Cut x2, Wild Cut x4`}</p>
    <p>{`Pick `}<strong parentName="p">{`$15000`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`If Partitio no Latent, T1 M1 Pom Ms M2, M2 HHB x3. T2 same except Throne HP Thief x4 instead of Attacks.`}</p>
      </blockquote>
      <h4 {...{
        "id": "rai-mei-55000hp-7s-sword-staff-ice-light-36000-collect"
      }}>{`Rai Mei 55000HP 7S (Sword Staff Ice Light) $36000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: HHB x3`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: Attack x4`}</li>
        <li parentName="ul">{`Hikari: Collect x4`}</li>
        <li parentName="ul">{`Partitio: `}{`[LP]`}{` HHB x4`}</li>
        <li parentName="ul">{`Throne: Attack x3`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Sai`}</strong>{`, head to `}<strong parentName="p">{`Ku`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: All Thief Skills`}</li>
        <li parentName="ul">{`Partitio: All Merchant Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-9"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Throne: -`}{`[2]`}{`Grow on Trees +`}{`[2]`}{`Life in the Shadows`}</li>
        <li parentName="ul">{`Partitio: -`}{`[2]`}{`Grow on Trees +`}{`[2]`}{`Full Power`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "ku-hikari-c5"
    }}>{`Ku (Hikari C5)`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You REALLY want to 2T Ritsu & Mugen. If not, almost certainly short for DmD, and will need to split menu and kill something before Assassins.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ritsu-75000hp-7s-spear-bow-fire-shadow-10000-collect"
      }}>{`Ritsu 75000HP 7S (Spear Bow Fire Shadow) $10000 Collect`}</h4>
      <blockquote>
        <p parentName="blockquote">{`There's 2 variations to this fight and the next one, the variation you choose is dependant on turn order.`}<br parentName="p"></br>{`
`}{`The one in notes is Temenos Abating Orb T1. Downside is it's a range that can miss by 800 with absolute min rolls.`}<br parentName="p"></br>{`
`}{`You can also have Temenos hit shields T1 and orb T2. The downside with this one is that if Temenos is last it's a 3T fight and you lose the JP bonus.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Attack x3`}</li>
        <li parentName="ul">{`Temenos: Abating Orb`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: HHB x4`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "king-mugen-80000hp-6s-spear-axe-thunder-light-18000-collect"
      }}>{`King Mugen 80000HP 6S (Spear Axe Thunder Light) $18000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-10"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: Attack x3`}</li>
        <li parentName="ul">{`Temenos: Abating Orb`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: HHB x4`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "hikari-25000hp-7s-sword-axe-light"
      }}>{`"Hikari" 25000HP 7S (Sword Axe Light)`}</h4>
      <p>{`Defend, HHV x4, HHG x4`}</p>
      <p>{`If lost money to Montwise reputation or something else, do: `}<strong parentName="p">{`Slowing Sweep`}</strong>{`, HHV x4, L Stone`}</p>
      <ul>
        <li parentName="ul">{`With Slowing Sweep, watch revealed weaknesses to see how many weakness hits you got.`}</li>
        <li parentName="ul">{`0: Fire L, 1: M Stone, 2: Attack x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "enshrouded-king-10s-sword-spear-bow-staff-thunder-wind-collect-26000"
      }}>{`Enshrouded King 10S (Sword Spear Bow Staff Thunder Wind) Collect $26000`}</h4>
      <h5 {...{
        "id": "turn-1-11"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Crit Scope`}</li>
        <li parentName="ul">{`Hikari: Attack`}</li>
        <li parentName="ul">{`Partitio: Defend`}</li>
        <li parentName="ul">{`Temenos: Wind L`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-10"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHG x4`}</li>
        <li parentName="ul">{`Temenos: Attack x4`}</li>
        <li parentName="ul">{`Throne: AC`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Merchants: HHB x4`}</li>
        <li parentName="ul">{`Throne: HP Thief x4`}</li>
      </ul>
    </Battle>
    <p>{`Go to `}<strong parentName="p">{`Weapon Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Throne: Unequip All`}</li>
      </ul>
      <h5 {...{
        "id": "weapon-sell"
      }}>{`Weapon Sell`}</h5>
      <ul>
        <li parentName="ul">{`Dancing Dagger`}</li>
        <li parentName="ul">{`Carnage Bow`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Crackridge Harbor`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-harbor-1"
    }}>{`Crackridge Harbor`}</h3>
    <p>{`Go buy `}<strong parentName="p">{`Battle-Tested Blade`}</strong>{` from Bandelam.`}</p>
    <p>{`TP `}<strong parentName="p">{`Cropdale`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cropdale"
    }}>{`Cropdale`}</h3>
    <p>{`Get `}<strong parentName="p">{`Agnea`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-2"
      }}>{`Party`}</h5>
      <p>{`[3]`}{`Agnea > `}{`[3]`}{`Partitio`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong></p>
    <h3 {...{
      "id": "montwise"
    }}>{`Montwise`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`Throne > Hikari`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Optimize +Champ Belt +Mighty Belt`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-6"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Warrior, All Warrior Skills, Armsmaster`}</li>
        <li parentName="ul">{`Temenos: Merchant`}</li>
        <li parentName="ul">{`Throne: `}{`[2U]`}{`Hunter, +Leghold +Abating Orb`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-10"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: -`}{`[4]`}{`Grow on Trees +`}{`[4]`}{`Peak Performance +`}{`[3]`}{`Deal More Damage`}</li>
        <li parentName="ul">{`Throne: -`}{`[1]`}{`A Step Ahead +`}{`[1]`}{`Heightened Senses`}</li>
      </ul>
    </Menu>
    <p>{`Head to `}<strong parentName="p">{`Merry Hills`}</strong>{`, running from battles.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Merry Hills`}</strong>{`. Go fight `}<strong parentName="p">{`Assassins`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "assassins"
      }}>{`Assassins`}</h4>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Divine Dual-Edge`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: HHB x4`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-agnea-c2-p1"
    }}>{`New Delsta (Agnea C2 P1)`}</h3>
    <p>{`Entreat `}<strong parentName="p">{`Fort M & Nourish M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After doing 1st Allure TP `}<strong parentName="p">{`Winterbloom`}</strong></p>
    <h3 {...{
      "id": "winterbloom-throne-c2f-p2"
    }}>{`Winterbloom (Throne C2F P2)`}</h3>
    <p>{`Go to Tavern, Hear a Tale to start Throne 2F.`}</p>
    <p><strong parentName="p">{`ENTREAT FORT L`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-1"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul"><em parentName="li">{`Consumables and press right to land on good spot to use nuts`}</em></li>
        <li parentName="ul">{`Nourish M > Temenos`}</li>
        <li parentName="ul">{`Nourish L > Throne`}</li>
        <li parentName="ul">{`Invig S > Hikari`}</li>
        <li parentName="ul">{`Fort Nuts > Hikari`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-7"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: +2 Merchant Skills`}</li>
        <li parentName="ul">{`Agnea: Scholar, +2 Skills, Merchant, +3 Skills, Inventor`}</li>
        <li parentName="ul">{`Temenos: `}{`[2D]`}{` Scholar`}</li>
      </ul>
    </Menu>
    <p>{`Switch to Night before Bergomi.`}</p>
    <Battle mdxType="Battle">
      <h5 {...{
        "id": "bergomi-15000hp-4s-sword-bow-fire"
      }}>{`Bergomi 15000HP 4S (Sword Bow Fire)`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Divine Dual-Edge x3`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-agnea-c2-p2"
    }}>{`New Delsta (Agnea C2 P2)`}</h3>
    <p>{`Take bottom path and Allure Lady on the way.`}<br parentName="p"></br>{`
`}{`Switch to night before boss`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lamani-13000hp-4s-spear-dagger-fire-ice-shadow"
      }}>{`La'mani 13000HP 4S (Spear Dagger Fire Ice Shadow)`}</h4>
      <ul>
        <li parentName="ul">{`Hikari: Divine Dual-Edge x3`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Tropu'hopu`}</strong>{`.`}</p>
    <h4 {...{
      "id": "tropuhopu-agnea-c3"
    }}>{`Tropu'hopu (Agnea C3)`}</h4>
    <p>{`Finish chapter, TP `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine-temenos-c2"
    }}>{`Canalbrine (Temenos C2)`}</h3>
    <p>{`Coerce top left suspect: Attack, LP Elemental Barrage x4`}<br parentName="p"></br>{`
`}{`Switch to day. Switch to night before fight.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vados-the-architecht-14000hp-6s-spear-dagger-ice-light"
      }}>{`Vados the Architecht 14000HP 6S (Spear Dagger Ice Light)`}</h4>
      <p>{`Divine Dual-Edge x3`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Sai`}</strong>{`.`}</p>
    <h4 {...{
      "id": "sai-agnea-c4"
    }}>{`Sai (Agnea C4)`}</h4>
    <p>{`Entreat `}<strong parentName="p">{`Champion's Garb`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-2"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Champion's Garb > Hikari`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-11"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: -`}{`[1]`}{`EM +`}{`[1]`}{`Full Power`}</li>
        <li parentName="ul">{`Agnea: +EM +Grow on Trees +Boost Start +A Step Ahead`}</li>
        <li parentName="ul">{`Throne: -`}{`[4]`}{`Peak Performance +`}{`[4]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle"> 
      <h4 {...{
        "id": "veronica-60000hp-6s-dagger-axe-fire-ice-shadow-12000-collect"
      }}>{`Veronica 60000HP 6S (Dagger Axe Fire Ice Shadow) $12000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-13"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Defend / Shinjumonjigiri x3`}</li>
        <li parentName="ul">{`Others: Attack x3 (Temenos LP)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-12"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x3 (Needs 1 of 2 crits to kill)`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wellgrove-throne-c3m"
    }}>{`Wellgrove (Throne C3M)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "mother-42000hp-6s-dagger-bow-ice-light-collect-6000"
      }}>{`Mother 42000HP 6S (Dagger Bow Ice Light) Collect $6000`}</h4>
      <h5 {...{
        "id": "turn-1-14"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Throne: Abating Orb Mother`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-13"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4 Mother`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crackridge-temenos-ch3"
    }}>{`Crackridge (Temenos Ch3)`}</h3>
    <p>{`Finish Chapter.`}</p>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise-throne-c3f-p2"
    }}>{`Montwise (Throne C3F P2)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "father-58000hp-7s-spear-dagger-axe-wind-light-collect-9600"
      }}>{`Father 58000HP 7S (Spear Dagger Axe Wind Light) Collect $9600`}</h4>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Throne: Abating Orb`}</li>
        <li parentName="ul">{`Agnea: Attack x3`}</li>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` E.Barrage x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-14"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x3`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stormhail-temenos-c3s"
    }}>{`Stormhail (Temenos C3S)`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "deputy-cubaryi-54000hp-5s-spear-axe-staff-19200-collect"
      }}>{`Deputy Cubaryi 54000HP 5S (Spear Axe Staff) $19200 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Agnea: Axe`}</li>
        <li parentName="ul">{`Throne: Axe`}</li>
        <li parentName="ul">{`Temenos: Attack x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-15"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x3`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Merry Hills`}</strong>{`.`}</p>
    <h3 {...{
      "id": "merry-hills-agnea-c5"
    }}>{`Merry Hills (Agnea C5)`}</h3>
    <p>{`Battle: Divine Dual-Edge x4`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SWITCH TO NIGHT`}</strong></p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dolciana-p1-58000hp-6s-spear-dagger-bow-ice-shadow"
      }}>{`Dolciana P1 58000HP 6S (Spear Dagger Bow Ice Shadow)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Can Abating Orb for +1800EXP (and some JP / Money). Costs like 7s.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Others: Attack x3 (Temenos LP)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-16"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x3`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dolciana-p2-90000hp-8s-sword-dagger-axe-fire-wind"
      }}>{`Dolciana P2 90000HP 8S (Sword Dagger Axe Fire Wind)`}</h4>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Others: Attack x3 (Temenos LP)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-17"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong></p>
    <h3 {...{
      "id": "new-delsta-throne-c4"
    }}>{`New Delsta (Throne C4)`}</h3>
    <p>{`After Ambush switch back to day`}</p>
    <p>{`Heal before Claude, `}<strong parentName="p">{`Switch to Night`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "claude-68000hp-9s-dagger-axe-staff-thunder-light-30000-collect"
      }}>{`Claude 68000HP 9S (Dagger Axe Staff Thunder Light) $30000 Collect`}</h4>
      <blockquote>
        <p parentName="blockquote">{`So basic idea here is people before Hikari hit shields & people after Defend.`}<br parentName="p"></br>{`
`}{`If Hikari is after Agnea & Temenos just Staff if needed.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Defend / Staff`}</li>
        <li parentName="ul">{`Agnea: Attack x3 / Defend`}</li>
        <li parentName="ul">{`Throne: Abating Orb`}</li>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` E.Barrage x3 / Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-18"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Defender: Break`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Tropu'hopu`}</strong>{`. Go to `}<strong parentName="p">{`Nameless Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "nameless-village-temenos-c4"
    }}>{`Nameless Village (Temenos C4)`}</h3>
    <p>{`Guide Story Guy.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` Before Fight`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "kaldena-100000hp-8s-spear-staff-ice-wind-collect-1200"
      }}>{`Kaldena 100000HP 8S (Spear Staff Ice Wind) Collect $1200`}</h4>
      <ul>
        <li parentName="ul">{`Hikari: Sixfold Strike`}</li>
        <li parentName="ul">{`Agnea: Crit Scope`}</li>
        <li parentName="ul">{`Throne: Abating Orb`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-19"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` E.Barrage x4`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "flamechurch-temenos--throne-c1"
    }}>{`Flamechurch (Temenos & Throne C1)`}</h3>
    <p>{`Go to Tavern.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-3"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1]`}{`Oswald > `}{`[3]`}{`Agnea`}</li>
      </ul>
      <h5 {...{
        "id": "hear-a-tale-1"
      }}>{`Hear a Tale`}</h5>
    </Menu>
    <p>{`Coerce Old Man: LATENT E.Barrage x3, Attack`}<br parentName="p"></br>{`
`}{`Guide Old Man`}</p>
    <p>{`If you used yours steal `}<strong parentName="p">{`Reinforcing Jam`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Finish Chapter. TP `}<strong parentName="p">{`Gravell`}</strong>{`.`}</p>
    <h3 {...{
      "id": "gravell-osvald-c5"
    }}>{`Gravell (Osvald C5)`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-8"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Merchant`}</li>
      </ul>
    </Menu>
    <p>{`Mug 1: HHV x2`}<br parentName="p"></br>{`
`}{`Mug 2: HHB x3`}<br parentName="p"></br>{`
`}{`Mug 3: HHV x3`}<br parentName="p"></br>{`
`}{`Mug 4: HHG x3`}<br parentName="p"></br>{`
`}{`Mug 5: HHV x3`}</p>
    <p>{`Run from battles in Duskruin.`}</p>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` before trigger.`}</p>
    <p>{`Small Golems: Divine Dual-Edge x3`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "harvey-80000hp-10s-spear-axe-fire-ice-thunder"
      }}>{`Harvey 80000HP 10S (Spear Axe Fire Ice Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-20"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Spear`}</li>
        <li parentName="ul">{`Throne: Axe x3`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-20"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: E.Barrage x4`}</li>
        <li parentName="ul">{`Throne: Abating Orb`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`, go to `}<strong parentName="p">{`Beasting Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-village"
    }}>{`Beasting Village`}</h3>
    <p>{`Talk to Ochette, `}<strong parentName="p">{`Choose Mahina`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-4"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[2]`}{`Castti > `}{`[2]`}{`Throne`}</li>
        <li parentName="ul">{`[3]`}{`Oswald > `}{`[4]`}{`Ochette`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-ochette-c2a"
    }}>{`Conning Creek (Ochette C2A)`}</h3>
    <p>{`Provoke Shadow L / M Stone`}<br parentName="p"></br>{`
`}{`Finish Chapter.`}</p>
    <h3 {...{
      "id": "cropdale-castti--ochette-c1"
    }}>{`Cropdale (Castti & Ochette C1)`}</h3>
    <p>{`Switch to Night before fight.`}<br parentName="p"></br>{`
`}{`Duorduor: Sword x3 (Hachimonjigiri x3 if Daytime)`}</p>
    <p>{`TP `}<strong parentName="p">{`Timberain`}</strong>{`.`}</p>
    <h3 {...{
      "id": "timberain-castti-c4"
    }}>{`Timberain (Castti C4)`}</h3>
    <p>{`On the way to Tavern `}<strong parentName="p">{`Bribe More Provisions`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After Rain starts go to Weapon Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <p>{`2 Imperial Armor, Equip on Castti and Ochette.`}<br parentName="p"></br>{`
`}{`1 Royal Guard Helm, Equip on Hikari.`}</p>
    </Menu>
    <p>{`If no L Stone for Joint Chapter Pick `}<strong parentName="p">{`Wind L`}</strong></p>
    <p>{`Kill both battles here with Divine Dual-Edge x3. Recommended but not required.`}</p>
    <p>{`Right before Trosseau, switch to Night and menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ochette: +Take Aim +Abating Orb (Take Aim is Optional, guarantees Vide P2)`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-12"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Castti: -`}{`[1]`}{`EM +`}{`[1]`}{`ASA`}</li>
        <li parentName="ul">{`Ochette: +`}{`[2]`}{`Heightened Senses +`}{`[3]`}{`A Step Ahead `}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "trousseau-95000hp-8s-spear-axe-ice-dark"
      }}>{`Trousseau 95000HP 8S (Spear Axe Ice Dark)`}</h4>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Abide`}</li>
        <li parentName="ul">{`Castti: Axe x2`}</li>
        <li parentName="ul">{`Ochette: Abating Orb`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-21"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` E.Barrage x4`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong></p>
    <h3 {...{
      "id": "crackridge-ochette-c2t"
    }}>{`Crackridge (Ochette C2T)`}</h3>
    <p>{`Switch to night, run out and look for Meep battle.`}</p>
    <p>{`Meep: Anyone but Ochette attack Meep (Hikari use Spear), rest Defend. Ochette Capture.`}<br parentName="p"></br>{`
`}{`Cook Meep into `}<strong parentName="p">{`Aromatic Jerky`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-skills-13"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Castti: +EM`}</li>
      </ul>
    </Menu>
    <p>{`After befriending Pom switch back to day, then `}<strong parentName="p">{`switch to night`}</strong>{` before Tera.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "terakun-43500hp-6s-dagger-axe-staff-ice-light"
      }}>{`Terakun 43500HP 6S (Dagger Axe Staff Ice Light)`}</h4>
      <p>{`Break + Shinju.`}</p>
    </Battle>
    <p>{`Finish Chapter, TP `}<strong parentName="p">{`Stormhail`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stormhail-ochette-c2g"
    }}>{`Stormhail (Ochette C2G)`}</h3>
    <p>{`Provoke: Shadow L x2. If you need to save a L Stone for Wriggling Shadow, can do Shadow L, Defend, Tera.`}</p>
    <p>{`Pick Reinforcing Jam if you've used any unrouted ones or want a spare. Need 1 for Vide.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "glacis-54000hp-8s-spear-dagger-bow-fire"
      }}>{`Glacis 54000HP 8S (Spear Dagger Bow Fire)`}</h4>
      <h5 {...{
        "id": "turn-1-22"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Defend if before Temenos / Spear`}</li>
        <li parentName="ul">{`Castti: Plum Hikari`}</li>
        <li parentName="ul">{`Ochette: Attack x2`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-22"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` E.Barrage x4`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4`}</li>
        <li parentName="ul">{`Ochette: Capture`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Beastling Village`}</strong></p>
    <h3 {...{
      "id": "beastling-village-ochette-c3"
    }}>{`Beastling Village (Ochette C3)`}</h3>
    <p>{`Go to Summit. Can do these battles during Day.`}</p>
    <p>{`3 Battles: Divine Dual-Edge x3`}</p>
    <p><strong parentName="p">{`SWITCH TO NIGHT`}</strong>{` for Lajackal`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lajackal-of-the-sorrowful-moon-96000hp-7s-dagger-bow-fire"
      }}>{`Lajackal of the Sorrowful Moon 96000HP 7S (Dagger Bow Fire)`}</h4>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Abide`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-23"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` E.Barrage x4`}</li>
        <li parentName="ul">{`Castti: Conoct x2 Forget-Me-Do + Sticky Flower + Blusterbloom`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Cropdale`}</strong></p>
    <h3 {...{
      "id": "cropdale-castti--ochette-c2"
    }}>{`Cropdale (Castti & Ochette C2)`}</h3>
    <p>{`Wriggling Shadow: Akala, Akala, Glacis, (Ice) L Stone`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "creeping-shadow-50000hp-6s-spear-axe-bow-ice-light"
      }}>{`Creeping Shadow 50000HP 6S (Spear Axe Bow Ice Light)`}</h4>
      <h5 {...{
        "id": "turn-1-24"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hiraki: Defend`}</li>
        <li parentName="ul">{`Castti: Attack x2`}</li>
        <li parentName="ul">{`Ochette: Attack x2`}</li>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` Attack x3 `}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-24"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Hikrai: Shinjumonjigiri x4`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "ryu-1"
    }}>{`Ryu`}</h3>
    <p>{`Go to Tavern`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-5"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[1]`}{`Agnea > `}{`[2]`}{`Castti`}</li>
        <li parentName="ul">{`[3]`}{`Ochette > `}{`[4]`}{`Osvald`}</li>
        <li parentName="ul">{`[3]`}{`Partitio > `}{`[4]`}{`Temenos`}</li>
      </ul>
      <h5 {...{
        "id": "hear-a-tale-2"
      }}>{`Hear a Tale`}</h5>
    </Menu>
    <p><strong parentName="p">{`TP New Delsta`}</strong></p>
    <h3 {...{
      "id": "new-delsta-osvald--partitio-c1"
    }}>{`New Delsta (Osvald & Partitio C1)`}</h3>
    <p>{`Finish chapter. TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise-osvald--partitio-c2"
    }}>{`Montwise (Osvald & Partitio C2)`}</h3>
    <p>{`Switch to night to move NPCs out of way.`}<br parentName="p"></br>{`
`}{`1st Battle Divine Dual-Edge x3, 2nd battle Shinjumonjigiri x3, Mug HHV x2`}</p>
    <p>{`TP `}<strong parentName="p">{`Ku`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ku-agnea--hikari-c2-p1"
    }}>{`Ku (Agnea & Hikari C2 P1)`}</h3>
    <p>{`Go to Tavern`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "party-6"
      }}>{`Party`}</h5>
      <ul>
        <li parentName="ul">{`[2]`}{`Throne > `}{`[4]`}{`Partitio`}</li>
        <li parentName="ul">{`[3]`}{`Osvald > `}{`[3]`}{`Temenos`}</li>
      </ul>
    </Menu>
    <p>{`Entreat stuff, TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-temenos--throne-c2-p1"
    }}>{`Conning Creek (Temenos & Throne C2 P1)`}</h3>
    <p>{`After Stealing map, TP `}<strong parentName="p">{`Ku`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ku-agnea--hikari-c2-p2"
    }}>{`Ku (Agnea & Hikari C2 P2)`}</h3>
    <p>{`Talk to Benkai.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Yomi`}</strong>{`: Slowing Sweep, Shinjumonjigiri x4 (Can Attack if first T2)`}<br parentName="p"></br>{`
`}{`Do not learn Forlorn Requiem`}</p>
    <p>{`TP `}<strong parentName="p">{`Conning Creek`}</strong>{`.`}</p>
    <h3 {...{
      "id": "conning-creek-temenos--throne-c2-p2"
    }}>{`Conning Creek (Temenos & Throne C2 P2)`}</h3>
    <p>{`Finish Temenos & Throne chapter. `}</p>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`, run to Campfire to start `}<strong parentName="p">{`Journey of the Dusk`}</strong>{`.`}</p>
    <h3 {...{
      "id": "journey-of-the-dusk"
    }}>{`Journey of the Dusk`}</h3>
    <p>{`Forced Battle: Divine Dual-Edge x3`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Ku`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ku"
    }}>{`Ku`}</h3>
    <p>{`Head to `}<strong parentName="p">{`Tranquil Grotto`}</strong>{`, Light Flame.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Flamechurch`}</strong>{`.`}</p>
    <h3 {...{
      "id": "flamechurch-1"
    }}>{`Flamechurch`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "arcanette-150000hp-8s-spear-axe-ice-thunder"
      }}>{`Arcanette 150000HP 8S (Spear Axe Ice Thunder)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`If you have Latent on Hikari it's possible to 1T this if you have Temenos + 1 more before Hikari`}<br parentName="p"></br>{`
`}{`Temenos + Other breaks, Hikari Hienka x3, other Pom L Hikari, Shinjumonjigiri`}<br parentName="p"></br>{`
`}{`Even if no Latent, if you have turn order above can do 2T with Shinjumonjigiri instead of Hienka.`}<br parentName="p"></br>{`
`}{`Listing standard 3T as it's the simplest.`}<br parentName="p"></br>{`
`}{`You can also 2T without Hienka with good turn order.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-25"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Pom M Self`}</li>
        <li parentName="ul">{`Agnea: Axe x3`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
        <li parentName="ul">{`Throne: Axe x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-25"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` Attack x4`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4`}</li>
      </ul>
    </Battle>
    <p>{`Go to Church, Light Flame.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Beastling Village`}</strong>{`. Go to `}<strong parentName="p">{`Tomb of the Wardenbeasts`}</strong>{` to light flame.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "grotesque-monster-120000hp-7s-axe-bow-ice-thunder"
      }}>{`Grotesque Monster 120000HP 7S (Axe Bow Ice Thunder)`}</h4>
      <h5 {...{
        "id": "turn-1-26"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x3 (Unbroken)`}</li>
        <li parentName="ul">{`Agnea: Pom L Hikari`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
        <li parentName="ul">{`Throne: Axe x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-26"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Temenos: `}{`[LP]`}{` Attack x4`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4`}</li>
      </ul>
    </Battle>
    <p>{`After fight get closer to flame and menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`[1]`}{`Castti > `}{`[4]`}{`Throne`}</li>
        <li parentName="ul">{`[2]`}{`Agnea > `}{`[4]`}{`Ochette`}</li>
      </ul>
      <h5 {...{
        "id": "items-3"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Refreshing Jam Hikari`}</li>
        <li parentName="ul">{`Shiny Mirror`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Crackridge`}</strong>{` next. `}</p>
    <h3 {...{
      "id": "crackridge-1"
    }}>{`Crackridge`}</h3>
    <p>{`Before lighting flame menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`[2]`}{`Partitio > `}{`[2]`}{`Ochette`}</li>
        <li parentName="ul">{`[3]`}{`Temenos > `}{`[3]`}{`Osvald`}</li>
      </ul>
      <h5 {...{
        "id": "items-4"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Shiny Mirror`}</li>
      </ul>
    </Menu>
    <p>{`After Lighting Flame, do this menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`[1]`}{`Throne > `}{`[2]`}{`Partitio`}</li>
        <li parentName="ul">{`[3]`}{`Oswald > `}{`[3]`}{`Temenos`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If no Throne Latent, Reinforcing Jam her if you have a spare or go to Canalbrine instead and inn.`}</p>
      </blockquote>
      <h5 {...{
        "id": "world-map"
      }}>{`World Map`}</h5>
      <ul>
        <li parentName="ul">{`TP `}<strong parentName="li">{`New Delsta Anchorage`}</strong></li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`, go to `}<strong parentName="p">{`Vidania`}</strong>{`.`}</p>
    <h3 {...{
      "id": "vidania"
    }}>{`Vidania`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vide-200000hp"
      }}>{`Vide 200000HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Watch crits on 1st Shinju if he's before Castti.`}<br parentName="p"></br>{`
`}{`Non Crit is 15k 20k, Crit is 18k 25k.`}<br parentName="p"></br>{`
`}{`If both Crit can skip Pom S.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-27"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x3 Vide`}</li>
        <li parentName="ul">{`Throne: Defend`}</li>
        <li parentName="ul">{`Temenos: Defend`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-27"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: `}{`[LP]`}{` Sword x4 Vide, Abating Orb`}</li>
        <li parentName="ul">{`Temenos: Attack x4 Vide`}</li>
        <li parentName="ul">{`Castti: Rev Jam Hikari`}</li>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x4 Vide`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Shinjumonjigiri x3`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vide-phase-2-250000hp"
      }}>{`Vide Phase 2 250000HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Take Aim guarantees the kill here. You have a very high crit rate without it though, and can miss 2/8.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-28"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Latent Springy Boots`}</li>
        <li parentName="ul">{`Ochette: Beastly Howl`}</li>
        <li parentName="ul">{`Partitio: Latent HHB x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-28"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Lion Dance x2 Hikari (1D)`}</li>
        <li parentName="ul">{`Ochette: Take Aim x2 / Defend`}</li>
        <li parentName="ul">{`Osvald: HHV/A x4`}</li>
        <li parentName="ul">{`Partitio: HHV/A x3`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Turn order is consistent T3 and on, Latent Spring Boots makes the game respect speed LMAO`}</p>
      </blockquote>
      <p>{`Party dies now.`}</p>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Throne: `}{`[LP]`}{` Attack x4, Armor Corrosive`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Hikari: Hienka x4`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Temenos: `}{`[LP]`}{` Attack x4`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Castti: Revitalizing Jam Hikari`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Hikari: Shinjumonjigiri x4`}</p>
        </li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Throne: Reinforcing Jam Hikari`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Hikari: Hienka x3`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Others: Defend`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Hikari: Shinjumonjigiri x4`}</p>
        </li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{` Go to campsite, start Epilogue. Timing ends after 2nd cutscene black screen. GG!`}</p>
    <hr></hr>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h6 {...{
      "id": "202-51523"
    }}>{`2.0.2 5/15/23`}</h6>
    <ul>
      <li parentName="ul">{`Cut Invig M`}</li>
      <li parentName="ul">{`Cut Fire L pickup.`}</li>
      <li parentName="ul">{`Cut Clockbank $6300`}</li>
      <li parentName="ul">{`Cut Coin / 1 M Stone, no spare stone to clear Bridge battle.`}</li>
      <li parentName="ul">{`Use HHB for Osvald 5 2nd Mug`}</li>
    </ul>
    <h6 {...{
      "id": "201-42623"
    }}>{`2.0.1 4/26/23`}</h6>
    <ul>
      <li parentName="ul">{`Move Osvald & Partitio Joint to endgame, no reason to do it early.`}</li>
      <li parentName="ul">{`Teach Temenos EM earlier (After Thurston), makes menus better.`}</li>
    </ul>
    <h6 {...{
      "id": "200-42523"
    }}>{`2.0.0 4/25/23`}</h6>
    <ul>
      <li parentName="ul">{`Big reroute based around JP Augmentor Skip`}</li>
      <li parentName="ul">{`Using early Merchant early game.`}</li>
      <li parentName="ul">{`Castti C2S and C2W done early for much improved pathing.`}</li>
      <li parentName="ul">{`Assassins done much later now, after Hikari 5`}</li>
      <li parentName="ul">{`Lot's of other stuff, too much to mention here.`}</li>
    </ul>
    <h6 {...{
      "id": "106-41623"
    }}>{`1.0.6 4/16/23`}</h6>
    <ul>
      <li parentName="ul">{`Merge NotNotArnaud's PR fixing some errors and spelling.`}</li>
      <li parentName="ul">{`Remove A Step Ahead from Hikari temporarily for Assassins > La'mani.`}</li>
    </ul>
    <h6 {...{
      "id": "105-41423"
    }}>{`1.0.5 4/14/23`}</h6>
    <ul>
      <li parentName="ul">{`Use Shadow Ms instead of Light Ms for Conning Night battles.`}</li>
      <li parentName="ul">{`Fix HP Thief learn spot, and add missing Heightened Senses on Osvald`}</li>
    </ul>
    <h6 {...{
      "id": "104-41323"
    }}>{`1.0.4 4/13/23`}</h6>
    <ul>
      <li parentName="ul">{`Crit formula is now known! It's (Crit - Enemy Speed)/200.`}</li>
      <li parentName="ul">{`Picking up 2 more crit nuts to guarantee crits on Arcanette, Dolcinaea, Grotesque, Trousseau, `}<strong parentName="li">{`Vide P1`}</strong>{`.`}</li>
      <li parentName="ul">{`Guaranteed crits on Vide P1 let's us cut a Reinforcing Jam, cutting the Ocean one.`}</li>
    </ul>
    <h6 {...{
      "id": "103-41023"
    }}>{`1.0.3 4/10/23`}</h6>
    <ul>
      <li parentName="ul">{`Slight restructure of early game money, no more collect Hire, skip Pom L buy in favor of Lychee M + Latent for Partitio. Inn stay instead of small lychees.`}</li>
      <li parentName="ul">{`Vide P1 Latent script is pretty slow, noted.`}</li>
      <li parentName="ul">{`Switch back to Akala because slightly faster animation on Provokes.`}</li>
      <li parentName="ul">{`Adjust menus with Agnea, get Heightened Senses on Ochette & Throne.`}</li>
    </ul>
    <h6 {...{
      "id": "102-4923"
    }}>{`1.0.2 4/9/23`}</h6>
    <ul>
      <li parentName="ul">{`Cut 20k Chest, use HHG on Enshrouded`}</li>
      <li parentName="ul">{`No Hang Tough on Partitio, double 2 person survivors for Vide`}</li>
    </ul>
    <h6 {...{
      "id": "101-more-precise-stone-routing-4823"
    }}>{`1.0.1 More Precise Stone Routing 4/8/23`}</h6>
    <h6 {...{
      "id": "100-initial-route-4823"
    }}>{`1.0.0 Initial Route 4/8/23`}</h6>
    <h3 {...{
      "id": "ideas--things-to-investigate"
    }}>{`Ideas / Things to Investigate`}</h3>
    <ul>
      <li parentName="ul"><del parentName="li">{`See how much early Invig M is worth`}</del>{` Want Invig M + Invig S on Hikari for 3 Shinjumonjigiri`}<ul parentName="li">
          <li parentName="ul">{`Might be better to just skip Invig M and mitigate with Rev Jams. We have 2 Spares atm.`}</li>
        </ul></li>
      <li parentName="ul">{`Find way to improve SP management around Sand Lion`}</li>
      <li parentName="ul">{`For Hikari chapters see if we can get overkill bonuses with minimal time investment`}</li>
      <li parentName="ul">{`Test extra Fort M for fights (Yomi and Agnea 5 adds). Saves time on both, but slightly not enough to pay for itself. Might need to test with some other ideas (Slowing Sweep Shadow Hikari)`}</li>
      <li parentName="ul"><del parentName="li">{`Try to work in Heightened Senses`}</del>{` It's worked in, question now is if it's worth it.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      